import { useMount } from '@cutwise/react-utils';
function RedirectPage(props) {
    const { to } = props;
    useMount(() => {
        window.location.href = to;
    });
    return null;
}
export default RedirectPage;
